import IconActions from '../../../shared/components/IconActions';
import React from 'react';
import PrimaryActionButton from '../../../shared/components/patterns/PrimaryActionButton';

const EDITABLE_FIELDS = [
  ['name', 'Nome workspace'],
  ['displayName', 'Nome visualizzato'],
  ['legalName', 'Ragione sociale'],
  ['contactEmail', 'Email contatto'],
  ['contactPhone', 'Telefono'],
  ['website', 'Sito web'],
  ['timezone', 'Timezone'],
  ['locale', 'Locale'],
  ['defaultCurrency', 'Valuta predefinita'],
  ['countryCode', 'Paese'],
  ['addressLine1', 'Indirizzo'],
  ['addressLine2', 'Indirizzo 2'],
  ['city', 'Citta'],
  ['postalCode', 'CAP'],
];

export default function WorkspaceSettingsPanel({ data, canManageWorkspaceSettings }) {
  if (!canManageWorkspaceSettings) {
    return (
      <section className="settings-card">
        <header className="settings-card__header">
          <h2 className="settings-card__title">Workspace</h2>
          <p className="settings-card__description">Non hai i permessi per modificare le impostazioni del workspace.</p>
        </header>
      </section>
    );
  }

  if (data.isLoading) {
    return (
      <section className="settings-card">
        <header className="settings-card__header">
          <h2 className="settings-card__title">Workspace</h2>
          <p className="settings-card__description">Caricamento impostazioni workspace...</p>
        </header>
      </section>
    );
  }

  return (
    <div className="settings-stack">
      <section className="settings-card">
        <header className="settings-card__header">
          <h2 className="settings-card__title">Profilo workspace</h2>
          <p className="settings-card__description">
            Impostazioni tenant-level persistite in auth-service. Piano e moduli restano read-only.
          </p>
        </header>
        <div className="settings-card__body">
          {data.error ? (
            <div role="alert" className="settings-alert settings-alert--error wt-inline-error">
              {data.error}
            </div>
          ) : null}

          {data.success ? (
            <div className="settings-alert settings-alert--success">
              {data.success}
            </div>
          ) : null}

          <div className="settings-form-grid settings-form-grid--workspace">
            {EDITABLE_FIELDS.map(([field, label]) => (
              <label className="settings-field" key={field} htmlFor={`workspace-${field}`}>
                <span>{label}</span>
                <input
                  id={`workspace-${field}`}
                  className="settings-input"
                  value={data.form[field] || ''}
                  onChange={(event) => data.updateField(field, event.target.value)}
                />
              </label>
            ))}
          </div>

          <div className="settings-actions settings-actions--right"><IconActions>
            <PrimaryActionButton
              disabled={data.isSaving || data.authRequired || data.unavailable}
              onClick={data.saveSettings}
              iconKey="actions.save"
            >
              {data.isSaving ? 'Salvataggio...' : 'Salva impostazioni workspace'}
            </PrimaryActionButton>
          </IconActions></div>
        </div>
      </section>

      <section className="settings-card">
        <header className="settings-card__header">
          <h2 className="settings-card__title">Piano e moduli attivi</h2>
          <p className="settings-card__description">Entitlements reali del tenant. Sono modificabili solo dal platform admin.</p>
        </header>
        <div className="settings-form-grid settings-form-grid--workspace">
          <ReadOnlyField label="Tenant ID" value={data.workspace?.tenantId} />
          <ReadOnlyField label="Slug" value={data.workspace?.slug} />
          <ReadOnlyField label="Piano" value={data.workspace?.planCode} />
          <ReadOnlyField
            label="Moduli attivi"
            value={(data.workspace?.enabledModuleKeys || []).join(', ')}
          />
        </div>
      </section>
    </div>
  );
}

function ReadOnlyField({ label, value }) {
  return (
    <label className="settings-field">
      <span>{label}</span>
      <input value={value || ''} disabled className="settings-input" readOnly />
    </label>
  );
}
